import type { PortalNumber } from "./owned-numbers";

type Page = { items: PortalNumber[]; nextCursor: string | null };
export async function loadNumberAssignments(
  api: <T>(path: string, options?: { signal?: AbortSignal }) => Promise<T>,
  signal: AbortSignal,
) {
  const items: PortalNumber[] = [];
  const seen = new Set<string>();
  let cursor: string | null = null;
  try {
    for (let page = 0; page < 100; page++) {
      signal.throwIfAborted();
      const result: Page = await api(
        `/admin/number-assignments${cursor ? `?after=${encodeURIComponent(cursor)}` : ""}`,
        { signal },
      );
      signal.throwIfAborted();
      for (const item of result.items) {
        if (seen.has(item.e164))
          throw new Error(
            "The assignment list changed while loading. Refresh numbers to check it again.",
          );
        seen.add(item.e164);
        items.push(item);
      }
      if (result.nextCursor === null)
        return { items, complete: true, error: "" };
      if (
        !result.items.length ||
        result.nextCursor !== result.items.at(-1)?.e164 ||
        (cursor !== null && result.nextCursor <= cursor)
      )
        throw new Error(
          "The assignment list could not be checked completely. Refresh numbers to retry.",
        );
      cursor = result.nextCursor;
    }
    throw new Error(
      "The portal assignment list exceeds 50,000 records. Unchecked numbers are marked below.",
    );
  } catch (cause) {
    if (signal.aborted) throw cause;
    return { items, complete: false, error: (cause as Error).message };
  }
}
